import millify from "millify"
import { useEffect } from "react"
import { useState } from "react"
import { getDashboardData } from "../../services/admin.service"
import { AdminFooter } from "../adminFooter/adminFooter.component"

export const AdminDashBoard = () => {
  const [newIdeas, setNewIdeas] = useState(0)
  const [approvedIdeas, setApprovedIdeas] = useState(0)
  const [rejectedIdeas, setRejectedIdeas] = useState(0)
  const [totalJury, setTotalJury] = useState(0)
  const [totalAreas, setTotalAreas] = useState(0)

  const getData = async () => {
    const { status, data } = await getDashboardData()
    if (status == 200) {
      setNewIdeas(data.newIdeas)
      setApprovedIdeas(data.approvedIdeas)
      setRejectedIdeas(data.rejectedIdeas)
      setTotalJury(data.totalJury)
      setTotalAreas(data.totalAreas)
    }
  }

  useEffect(() => {
    getData()
  }, [])
  return (
    <>
      <div className="app-content content">
        <div className="content-overlay" />
        <div className="header-navbar-shadow" />
        <div className="content-wrapper">
          <div className="content-body">
            <div className="row">
              <div className="col-12">
                <h2 className="mb-0">DASHBOARD</h2>
                {/* <p className="font-lato font-12">Feb 2022 to Mar 2022</p> */}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-12">
                <div className="card border border-2 border-primary">
                  <div className="card-body pb-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-12 line-height-10 font-weight-600">
                          NEW IDEAS
                        </p>
                        <p className="mb-0 font-10 opacity-50 font-lato">Total</p>
                      </div>
                      <div className="col-6 text-right">
                        <i className="fas fa-lightbulb opacity-50 font-25" />
                      </div>
                    </div>
                    <hr className="my-0" />
                    <div className="row">
                      <div className="col-6">
                        <h1 className="mb-0 font-60">{millify(newIdeas)}</h1>
                      </div>
                      {/* <div className="col-6 text-right">
                        <button
                          type="button"
                          className="btn btn-info text-white rounded-10 font-11 font-lato mt-2 waves-effect waves-float waves-light"
                        >
                          View all
                        </button>
                      </div> */}
                    </div>
                  </div>
                  {/* <div className="card-footer bg-comments-card-footer py-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-lato font-10 font-weight-600">
                          <img
                            src="assets/images/li-icon.svg"
                            alt="img"
                            className="mr-5"
                          />
                          GROWTH
                        </p>
                      </div>
                      <div className="col-6 text-right">
                        <p className="mb-0 font-lato font-12 font-weight-600">
                          78.7%<span className="font-10 ml-5 text-success">+4.2</span>
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <div className="card border border-2 border-success">
                  <div className="card-body pb-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-12 line-height-10 font-weight-600">
                          IDEAS APPROVED
                        </p>
                        <p className="mb-0 font-10 opacity-50 font-lato">Total</p>
                      </div>
                      <div className="col-6 text-right">
                        <i className="fas fa-lightbulb font-25 text-success" />
                      </div>
                    </div>
                    <hr className="my-0" />
                    <div className="row">
                      <div className="col-6">
                        <h1 className="mb-0 font-60">{millify(approvedIdeas)}</h1>
                      </div>
                      {/* <div className="col-6 text-right">
                        <button
                          type="button"
                          className="btn btn-info text-white rounded-10 font-11 font-lato mt-2 waves-effect waves-float waves-light"
                        >
                          View all
                        </button>
                      </div> */}
                    </div>
                  </div>
                  {/* <div className="card-footer bg-comments-card-footer py-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-lato font-10 font-weight-600">
                          <img
                            src="assets/images/li-icon.png"
                            alt="img"
                            className="mr-5"
                          />
                          DECLINE
                        </p>
                      </div>
                      <div className="col-6 text-right">
                        <p className="mb-0 font-lato font-12 font-weight-600">
                          19.6%<span className="font-10 ml-5 text-danger">-28.8</span>
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <div className="card border border-2 border-danger">
                  <div className="card-body pb-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-12 line-height-10 font-weight-600">
                          IDEAS REJECTED
                        </p>
                        <p className="mb-0 font-10 opacity-50 font-lato">Total</p>
                      </div>
                      <div className="col-6 text-right">
                        <i className="fas fa-lightbulb font-25 text-danger" />
                      </div>
                    </div>
                    <hr className="my-0" />
                    <div className="row">
                      <div className="col-6">
                        <h1 className="mb-0 font-60">{millify(rejectedIdeas)}</h1>
                      </div>
                      {/* <div className="col-6 text-right">
                        <button
                          type="button"
                          className="btn btn-info text-white rounded-10 font-11 font-lato mt-2 waves-effect waves-float waves-light"
                        >
                          View all
                        </button>
                      </div> */}
                    </div>
                  </div>
                  {/* <div className="card-footer bg-comments-card-footer py-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-lato font-10 font-weight-600">
                          <img
                            src="assets/images/li-icon.png"
                            alt="img"
                            className="mr-5"
                          />
                          DECLINE
                        </p>
                      </div>
                      <div className="col-6 text-right">
                        <p className="mb-0 font-lato font-12 font-weight-600">
                          19.6%<span className="font-10 ml-5 text-danger">-28.8</span>
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <div className="card">
                  <div className="card-body pb-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-12 line-height-10 font-weight-600">
                          TOTAL JURY MEMBERS
                        </p>
                        <p className="mb-0 font-10 opacity-50 font-lato">
                          Till today
                        </p>
                      </div>
                      <div className="col-6 text-right">
                        <i className="fas fa-crown opacity-50 font-25" />
                      </div>
                    </div>
                    <hr className="my-0" />
                    <div className="row">
                      <div className="col-6">
                        <h1 className="mb-0 font-60">{millify(totalJury)}</h1>
                      </div>
                      {/* <div className="col-6 text-right">
                        <button
                          type="button"
                          className="btn btn-info text-white rounded-10 font-11 font-lato mt-2 waves-effect waves-float waves-light"
                        >
                          View all
                        </button>
                      </div> */}
                    </div>
                  </div>
                  {/* <div className="card-footer bg-comments-card-footer py-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-lato font-10 font-weight-600">
                          <img
                            src="assets/images/li-icon.svg"
                            alt="img"
                            className="mr-5"
                          />
                          GROWTH
                        </p>
                      </div>
                      <div className="col-6 text-right">
                        <p className="mb-0 font-lato font-12 font-weight-600">
                          78.7%<span className="font-10 ml-5 text-success">+4.2</span>
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <div className="card">
                  <div className="card-body pb-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-12 line-height-10 font-weight-600">
                          TOTAL IMPLEMENT AREAS
                        </p>
                        <p className="mb-0 font-10 opacity-50 font-lato">
                          Till today
                        </p>
                      </div>
                      <div className="col-6 text-right">
                        <i className="fas fa-tag opacity-50 font-25" />
                      </div>
                    </div>
                    <hr className="my-0" />
                    <div className="row">
                      <div className="col-6">
                        <h1 className="mb-0 font-60">{millify(totalAreas)}</h1>
                      </div>
                      {/* <div className="col-6 text-right">
                        <button
                          type="button"
                          className="btn btn-info text-white rounded-10 font-11 font-lato mt-2 waves-effect waves-float waves-light"
                        >
                          View all
                        </button>
                      </div> */}
                    </div>
                  </div>
                  {/* <div className="card-footer bg-comments-card-footer py-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-lato font-10 font-weight-600">
                          <img
                            src="assets/images/li-icon.svg"
                            alt="img"
                            className="mr-5"
                          />
                          GROWTH
                        </p>
                      </div>
                      <div className="col-6 text-right">
                        <p className="mb-0 font-lato font-12 font-weight-600">
                          78.7%<span className="font-10 ml-5 text-success">+4.2</span>
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* <div className="col-lg-4 col-12">
                <div className="card">
                  <div className="card-body pb-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-12 line-height-10 font-weight-600">
                          TOTAL DEPARTMENTS
                        </p>
                        <p className="mb-0 font-10 opacity-50 font-lato">
                          Till today
                        </p>
                      </div>
                      <div className="col-6 text-right">
                        <i className="fas fa-building opacity-50 font-25" />
                      </div>
                    </div>
                    <hr className="my-0" />
                    <div className="row">
                      <div className="col-6">
                        <h1 className="mb-0 font-60">0</h1>
                      </div>
                      <div className="col-6 text-right">
                        <button
                          type="button"
                          className="btn btn-info text-white rounded-10 font-11 font-lato mt-2 waves-effect waves-float waves-light"
                        >
                          View all
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-comments-card-footer py-5">
                    <div className="row">
                      <div className="col-6">
                        <p className="mb-0 font-lato font-10 font-weight-600">
                          <img
                            src="assets/images/li-icon.svg"
                            alt="img"
                            className="mr-5"
                          />
                          GROWTH
                        </p>
                      </div>
                      <div className="col-6 text-right">
                        <p className="mb-0 font-lato font-12 font-weight-600">
                          78.7%<span className="font-10 ml-5 text-success">+4.2</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            <AdminFooter />
          </div>
        </div>
      </div>

    </>
  )
}